module.exports = __webpack_public_path__ + "static/media/close-envelope.59b027ea.svg";